import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ME_Fit } from 'me-fit-typings';

type WorkoutDisplayStepPipeParams = Pick<ME_Fit.WorkoutStep, 'sets' | 'value' | 'type' | 'weightValue'>;

/**
 * @deprecated Use me-workout-step instead. This pipe is used to display the workout step in a human readable format.
 */
@Pipe({
  name: 'workoutStepDisplay',
  pure: true
})
export class WorkoutStepDisplayPipe implements PipeTransform {

  constructor(private $translate: TranslateService) {}

  transform(workoutStep: WorkoutDisplayStepPipeParams, weightUnitOfMeasure: string): string {
    // TODO: locale calculation, convert kg to pounds for americans/lb preferring users
    let weightValueLabel = '';

    if (workoutStep.weightValue) {
      weightValueLabel = `(${workoutStep.weightValue}${weightUnitOfMeasure})`;
    }

    const setsLabel = this.getSetsLabel(workoutStep.sets);

    return `${setsLabel} x ${this.getLabelForValue(workoutStep)} ${weightValueLabel}`;
  }


  getLabelForValue({type, value}: Pick<ME_Fit.WorkoutStep, 'value' | 'type'>) {
    if (type === 'repetitions') {
      return `${value} ${this.getWorkoutStepTypeLabel(type)}`;
    }

    const timeMapping = {
      hours: {
        singular: this.$translate.instant('hour'),
        multiple: this.$translate.instant('hour.plural')
      },
      minutes: {
        singular: this.$translate.instant('minute'),
        multiple: this.$translate.instant('minute.plural')
      },
      seconds: {
        singular: this.$translate.instant('second'),
        multiple: this.$translate.instant('second.plural')
      }
    }
    const seconds = value;

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    let labelForTime = '';

    if (hours > 0) {
      labelForTime += `${hours} ${hours > 1 ? timeMapping.hours.multiple : timeMapping.hours.singular} `;
    }
    if (minutes > 0) {
      labelForTime += `${minutes} ${minutes > 1 ? timeMapping.minutes.multiple : timeMapping.minutes.singular} `;
    }

    if (remainingSeconds > 0) {
      labelForTime += `${remainingSeconds} ${remainingSeconds > 1 ? timeMapping.seconds.multiple : timeMapping.seconds.singular} `;
    }

    return labelForTime;
  }

  getWorkoutStepTypeLabel(type: ME_Fit.WorkoutStepType) {
    const suffixCharacterMap: { [key in ME_Fit.WorkoutStepType]: string } = {
      interval: this.$translate.instant('duration'),
      repetitions: this.$translate.instant('repetition.plural')
    }

    return suffixCharacterMap[type];
  }

  getSetsLabel(sets: WorkoutDisplayStepPipeParams['sets']) {
    const stepsI18nLabel = sets > 1 ? 'sets' : 'sets.singular';

    return `${sets} ${this.$translate.instant(stepsI18nLabel)}`;
  }



}
